import {
  evaluateSupportingTexts,
  type SkipAnswers,
  type SupportingTextBlock,
} from '@assessments/shared'

export interface PlacedSupportingTexts {
  above: SupportingTextBlock[]
  below: SupportingTextBlock[]
}

export const EMPTY_SUPPORTING_TEXTS: ReadonlyMap<string, PlacedSupportingTexts> = new Map()

/**
 * The blocks to render under each question id, for the answers on screen and the
 * questions skip logic hides. Server order is kept, so blocks sharing a place read
 * oldest first. Content is never blank: the API drops blank blocks.
 */
export function deriveVisibleSupportingTexts(
  blocks: readonly SupportingTextBlock[],
  answers: SkipAnswers,
  hidden: ReadonlySet<string>,
): ReadonlyMap<string, PlacedSupportingTexts> {
  if (blocks.length === 0) return EMPTY_SUPPORTING_TEXTS
  const visible = evaluateSupportingTexts(blocks, answers, hidden)
  const placed = new Map<string, PlacedSupportingTexts>()
  for (const block of blocks) {
    if (!visible.has(block.id)) continue
    let slot = placed.get(block.questionId)
    if (!slot) {
      slot = { above: [], below: [] }
      placed.set(block.questionId, slot)
    }
    ;(block.position === 'above' ? slot.above : slot.below).push(block)
  }
  return placed
}
